import { memo } from "react";
import Slider, { type InaccessibleRegion, type SliderProps } from "src/components/Slider";
import { BoldText, RegularText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

export interface LabeledSliderProps extends SliderProps {
  formatter: (val: number) => string;
  labelFormatter?: (val: number) => string;
  secondaryLabel?: string;
  labelClassName?: string;
  className?: string;
  color?: string;
  inaccessibleRegions?: InaccessibleRegion[];
  hideMin?: boolean;
  hideMax?: boolean;
}

const LabeledSlider = ({
  min,
  max,
  value,
  onChange,
  step,
  formatter,
  labelFormatter,
  secondaryLabel,
  markers,
  className,
  labelClassName,
  color,
  inaccessibleRegions,
  hideMin,
  hideMax,
}: LabeledSliderProps) => (
  <div className={cn("flex flex-col w-full", className)}>
    <div className={cn("w-full flex flex-row justify-between", secondaryLabel && "flex-row-reverse")}>
      <BoldText className={cn("text-2xl mb-[10px]", labelClassName)}>
        {labelFormatter ? labelFormatter(value) : formatter(value)}
      </BoldText>
      {secondaryLabel && (
        <BoldText className={cn("text-2xl mb-[10px]", labelClassName)}>{secondaryLabel}</BoldText>
      )}
    </div>
    <Slider
      color={color}
      markers={markers}
      min={min}
      max={max}
      value={value}
      step={step}
      onChange={onChange}
      inaccessibleRegions={inaccessibleRegions}
    />
    <div className="mt-[10px] flex justify-between w-full h-[15px]">
      {!hideMin ? <RegularText className="text-xs text-gray-600">{formatter(min)}</RegularText> : <div />}
      {!hideMax ? <RegularText className="text-xs text-gray-600">{formatter(max)}</RegularText> : <div />}
    </div>
  </div>
);

export default memo(LabeledSlider);
